import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { CreateAdoProduct } from './CreateAdoProductExtension';

export const CreateAdoProductFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'CreateAdoProduct',
    component: CreateAdoProduct,
  }),
);
